'use client'

import React, {useEffect, useState} from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import {PricingFullImage} from "../../assets/assets";
import {sendSlackMessageTracked} from "../../models/notifications";

export default function MainPopupForm() {
    const [open, setOpen] = useState(true)

    const [emailAddress, setEmailAddress] = useState("");
    const [name, setName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");


    useEffect(() => {
        // TODO: Pull data from local storage if we dismissed main popup
        // TODO: IF we did, then set 'open' to false
        // TODO: Else do nothing

        if (!open) {
            // TODO: Set local storage variable 'dismissed_main_popup'
            // TODO: Expires after 5 minutes if they deny. Expires after 5 days if they subscribed.
            // TODO: Add slack alert when they click "Not now"
        }
    }, [open])

    return (
        <Dialog open={open} onClose={setOpen} className="relative z-10" style={{zIndex: 9999}}>
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full w-full items-end justify-center p-4 text-center sm:items-center sm:p-0 ">
                    <DialogPanel
                        transition
                        className="flex justify-center items-center h-1/4 md:w-1/2 transform bg-white overflow-hidden rounded-lg text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 data-closed:sm:translate-y-0 data-closed:sm:scale-95"
                    >

                        <div className="flex items-center space-x-12">
                            <div className="">
                                <img src={PricingFullImage} className="rounded-r-0 w-7/8" />
                            </div>
                            <div className="w-7/8 pr-12">
                                <div >
                                    <div className="mt-12 text-center sm:mt-5">
                                        <DialogTitle as="h3" className="text-3xl font-semibold text-gray-900">
                                            Subscribe to the Pabloo newsletter.
                                        </DialogTitle>
                                        <div className="mt-2">
                                            <p className="text-2xl text-gray-500">
                                                The Pabloo newsletter teaches how to become an expert in store credit.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="mt-4 mb-4 text-center">
                                        <form className="mt-6 space-y-3 sm:max-w-md lg:mt-0" onSubmit={(event) => {
                                            event.preventDefault()

                                            sendSlackMessageTracked(`💸💸Future client has submitted their information via the popup form: \nEmail: ${emailAddress} - Name: ${name} - Email: ${emailAddress} - Number: ${phoneNumber}`)
                                            setOpen(false)
                                        }}>
                                            <label htmlFor="email-address" className="sr-only">
                                                Email address
                                            </label>
                                            <input
                                                id="email-address"
                                                name="email-address"
                                                type="email"
                                                required
                                                placeholder="Enter your email"
                                                autoComplete="email"
                                                value={emailAddress}
                                                onChange={(e) => {
                                                    setEmailAddress(e.target.value)
                                                }}
                                                className="w-full min-w-0 rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:w-56 sm:text-sm/6"
                                            />
                                            <input
                                                id="full-name"
                                                name="full-name"
                                                type="name"
                                                required
                                                placeholder="Enter your name"
                                                autoComplete="name"
                                                value={name}
                                                onChange={(e) => {
                                                    setName(e.target.value)
                                                }}
                                                className="w-full min-w-0 rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:w-56 sm:text-sm/6"
                                            />
                                            <input
                                                id="phone-number"
                                                name="phone-number"
                                                type="phone"
                                                placeholder="Optional phone number"
                                                autoComplete="phone number"
                                                value={phoneNumber}
                                                onChange={(e) => {
                                                    setPhoneNumber(e.target.value)
                                                }}
                                                className="w-full min-w-0 rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:w-56 sm:text-sm/6"
                                            />

                                            <div
                                                className="mt-5 sm:mt-12" style={{marginTop: '36px'}}>
                                                <button

                                                    type="submit"
                                                    className="inline-flex w-full justify-center rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
                                                >
                                                    Subscribe
                                                </button>
                                                <div
                                                    type="button"
                                                    data-autofocus
                                                    onClick={() => {
                                                        sendSlackMessageTracked(`❌❌Lead clicked the "not now" button on the popup.`)
                                                        setOpen(false)
                                                    }}
                                                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                                                >
                                                    Not now
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
}
